import React, { createContext, useState } from "react";

import { Icon, ICONS } from "../../Icons";
import {
  Wrapper,
  NotificationContainer,
  NotificationText,
  CloseIconWrapper,
  StyledCloseIcon
} from "./styled";

export const MobileNotificationContext = createContext({});

export const MobileNotification = ({ children }) => {
  const [isDisplayNotification, setDisplayNotification] = useState(true);

  return (
    <MobileNotificationContext.Provider value={isDisplayNotification}>
      <Wrapper>
        {/* previous code - <div className="show-on-mobile"> */}
        <div className="display-none">
          {isDisplayNotification && (
            <NotificationContainer>
              <NotificationText>
                Use the desktop to access all the services of Quick Apply
              </NotificationText>
              <CloseIconWrapper>
                <Icon
                  name={ICONS.closeWhite}
                  className={StyledCloseIcon}
                  onClick={() => setDisplayNotification(false)}
                />
              </CloseIconWrapper>
            </NotificationContainer>
          )}
        </div>
      </Wrapper>
      {children}
    </MobileNotificationContext.Provider>
  );
};
